import { maskAddressValue } from '@/utils/format';

import {
  EventTriggerType,
  MORPHO_MARKET_STRATEGY_TYPE_LABELS,
  MorphoBorrowerStrategyType,
  Trigger,
} from '../../domain';
import { TriggerType } from './components/TriggerType';
import { TriggerValueDetail } from './components/TriggerValueDetail';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const MorphoBorrowerStrategyTriggerDetails = ({ trigger, triggerType }: Props) => {
  const rawType = trigger.context?.type;
  const strategyLabel =
    rawType && rawType in MORPHO_MARKET_STRATEGY_TYPE_LABELS
      ? MORPHO_MARKET_STRATEGY_TYPE_LABELS[rawType as MorphoBorrowerStrategyType]
      : (rawType ?? '-');

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      <TriggerValueDetail label="Market ID" value={maskAddressValue(trigger.context?.market_address)} />
      <TriggerValueDetail label="Strategy type" value={strategyLabel} />
    </div>
  );
};
